import { cn } from 'utils';

import { ButtonContent } from './components/ButtonContent';
import { getVariantClasses } from './helpers/getVariantClasses';
import { useDynamicStyles } from './hooks/useDynamicStyles';
import { RButtonPropTypes } from './RButton.propTypes';
import { RButtonVariants } from './Loader';

const BASE_CLASS_NAME =
  'w-auto py-0 px-[8px] text-[14px] font-medium border border-solid border-transparent rounded-[8px] overflow-hidden transition-all duration-150 ease-linear cursor-pointer';

export function RButton({
  type = 'button',
  variant,
  variantColor,
  prependIcon,
  fullWidth,
  name,
  height = 46,
  disabled = false,
  loading = false,
  onClick = () => {},
  children,
  css,
  form,
  innerRef,
  className,
  style,
  as: Component = 'button',
  ...rest
}) {
  const { cssClassName, cssSheet } = useDynamicStyles(css);
  const isDefaultVariant = !Object.values(RButtonVariants).includes(variant);
  const hasCssHeight = css?.height !== undefined && css?.height !== null;

  return (
    <Component
      type={type}
      disabled={disabled}
      onClick={disabled || loading ? null : onClick}
      form={form}
      name={name}
      {...rest}
      ref={innerRef}
      className={cn(
        BASE_CLASS_NAME,
        fullWidth && 'w-full',
        getVariantClasses({
          variant,
          variantColor,
          disabled,
          fullWidth,
        }),
        cssSheet && cssClassName,
        className
      )}
      style={{
        ...(hasCssHeight ? null : { height: `${height}px` }),
        ...(isDefaultVariant && variantColor
          ? { '--rbtn-bg': variantColor }
          : null),
        ...style,
      }}
    >
      <ButtonContent
        prependIcon={prependIcon}
        disabled={disabled}
        loading={loading}
      >
        {children}
      </ButtonContent>
    </Component>
  );
}

RButton.propTypes = RButtonPropTypes;
